import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import * as constants from './constants/Constants';
import PubNub from 'pubnub';
import { PubNubProvider } from 'pubnub-react';
import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/dashboard';
import Layout from './pages/layout/layout';
import CreateRFQ from './pages/dashboard/RFQForm1';
import RFQForm2 from './pages/dashboard/RFQForm2';
import Quatation from './pages/quatations/quatation';
import QuotationDetails from './pages/quatations/quatationDetails';
import ReviewQuotation from './pages/quatations/reviewQuatation';
import SupplierList from './pages/suppliers/suppliers';
import PaymentProcessing from './pages/quatations/payment';
import SupplierProfile from './pages/suppliers/supplierProfile';
import DashboardAdmin from './pages/adminDashboard/dashboardAdmin';
import SuppliersAdmin from './pages/adminSuppliers/suppliersAdmin';
import Orders from './pages/orders/orders';
import OrderDetails from './pages/orders/orderDetails';
import ProfileSettings from './pages/profile/profile';
import CompanyInformation from './pages/profile/companyInfo';
import ContactInformation from './pages/profile/contactinfo';
import Documents from './pages/profile/documents';
import UserManagement from './pages/profile/Users';
import { ToastContainer, toast } from 'react-toastify';
import PrivateRoute from './components/PrivateRoute';
import NoPage from './pages/NoPage';
import BuyersAdmin from './pages/adminBuyers/buyers';
import VendorQuatation from './pages/Vendor/VendorQuatation';
import VendorQuatationDetails from './pages/Vendor/VendorQuatationDetails';
import VendorQuotationForm from './pages/Vendor/VendorQuoteForm';
import VendorOrders from './pages/Vendor/Orders';
import VendorOrderDetails from './pages/Vendor/VendorOrderDetails';
import Messages from './pages/layout/messages';
import ChatWindow from './pages/layout/chatwindow';
import ChatPage from './pages/suppliers/ChatPage';


function App() {
      const isLoggedIn = !!localStorage.getItem('token');


    const wrapPrivateRoute = (element) => (
        <PrivateRoute>{element}</PrivateRoute>
    );

const pubnub = new PubNub({
  publishKey: constants.pub_nub_publishKey,
  subscribeKey: constants.pub_nub_subscribeKey,
  uuid: constants.pub_nub_uuid,
});
  return (
    <PubNubProvider client={pubnub}>
      <div>
         <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                    />
                      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
               {isLoggedIn && (
                <>
  <Route element={<Layout />}>

            <Route path="/profile" element={wrapPrivateRoute(<ProfileSettings />)} />
            <Route path="/companyinfo" element={wrapPrivateRoute(<CompanyInformation />)} />
            <Route path="/contactinfo" element={wrapPrivateRoute(<ContactInformation />)} />
            <Route path="/documnets" element={wrapPrivateRoute(<Documents />)} />
            <Route path="/users" element={wrapPrivateRoute(<UserManagement />)} />
            <Route path="/dashboard" element={wrapPrivateRoute(<Dashboard />)} />
            <Route path="/rfq" element={wrapPrivateRoute(<CreateRFQ />)} />
            <Route path="/rfq2" element={wrapPrivateRoute(<RFQForm2 />)} />
            <Route path="/quatation" element={wrapPrivateRoute(<Quatation />)} />
            <Route path="/vendor_quatation" element={wrapPrivateRoute(<VendorQuatation />)} />
            <Route path="/vendor_quatation_details/:id" element={wrapPrivateRoute(<VendorQuatationDetails />)} />
            <Route path="/vendor_quatation_form/:id" element={wrapPrivateRoute(<VendorQuotationForm />)} />
            <Route path="/vendor_orders" element={wrapPrivateRoute(<VendorOrders />)} />
            <Route path="/vendor_order_details/:id" element={wrapPrivateRoute(<VendorOrderDetails />)} />            
            <Route path="/quotationDetails/:id" element={wrapPrivateRoute(<QuotationDetails />)} />
            <Route path="/reviewQuatation/:id" element={wrapPrivateRoute(<ReviewQuotation />)} />
            <Route path="/suppliers" element={wrapPrivateRoute(<SupplierList />)} />
            <Route path="/payment" element={wrapPrivateRoute(<PaymentProcessing />)} />
            <Route path="/supplierProfile" element={wrapPrivateRoute(<SupplierProfile />)} />
            <Route path="/admindashboard" element={wrapPrivateRoute(<DashboardAdmin />)} />
            <Route path="/adminsupplier" element={wrapPrivateRoute(<SuppliersAdmin />)} />
            <Route path="/adminbuyer" element={wrapPrivateRoute(<BuyersAdmin />)} />
            <Route path="/orders" element={wrapPrivateRoute(<Orders />)} />
            <Route path="/orderDetails/:id" element={wrapPrivateRoute(<OrderDetails />)} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/404" element={wrapPrivateRoute(<NoPage />)} />

          </Route>
                      <Route path="/chat" element={<ChatWindow />} />
                      <Route path="/chat-contact" element={<ChatPage />} />

               </> ) }
      
        </Routes>
      </BrowserRouter>
      </div>
    
    </PubNubProvider>
  );
}

export default App;
